import { render } from "./AboutSection.vue?vue&type=template&id=667d9474&scoped=true&ts=true"
import script from "./AboutSection.vue?vue&type=script&lang=ts"
export * from "./AboutSection.vue?vue&type=script&lang=ts"

import "./AboutSection.vue?vue&type=style&index=0&id=667d9474&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667d9474"]])

export default __exports__